import { configureStore } from '@reduxjs/toolkit';
import { apiMiddleware } from '@gjensidige/se-redux-api-middleware';

import offerReducer from './slices/offerSlice';

export const store = configureStore({
  reducer: {
    insurance: offerReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiMiddleware)
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
